import { useState } from "react";
import MetricAPIDataSourceImpl from "../../Data/DataSource/API/MetricAPIDataSource";
import { MetricRepositoryImpl } from "../../Data/Repository/MetricRepositoryImpl";
import { Metric, MonthlySales, TopSellingProducts } from "../../Domain/Model/Metric";
import { GetLowStockProducts } from "../../Domain/UseCase/getLowStockProducts";
import { GetMetrics } from "../../Domain/UseCase/getMetrics";
import { GetMonthlySales } from "../../Domain/UseCase/getMonthlySales";


export default function HomeViewModel() {
    const [metrics, setMetrics] = useState<Metric>();
    const [lowStockProducts, setLowStockProducts] = useState<TopSellingProducts[]>();
    const [monthlySales, setMonthlySales] = useState<MonthlySales[]>();
    
    const metricDataSourceImpl = new MetricAPIDataSourceImpl();
    const metricRepositoryImpl = new MetricRepositoryImpl(metricDataSourceImpl);

    const getMetricsUseCase = new GetMetrics(metricRepositoryImpl);
    const getLowStockProductsUseCase = new GetLowStockProducts(metricRepositoryImpl);
    const getMonthlySalesUseCase = new GetMonthlySales(metricRepositoryImpl);

    
        async function getMetrics(): Promise<Metric> {
            try {
                    const result: Metric = await getMetricsUseCase.invoke();
                
                    setMetrics(result);
                    
                
                    return result;
                  } catch (error) {
                    console.error("Error al obtener Clientes:", error);
                    return {} as Metric;
                  }
          }
          async function getLowStockProducts(): Promise<TopSellingProducts[]> {
            try {
                    const result: TopSellingProducts[] = await getLowStockProductsUseCase.invoke();
                
                    setLowStockProducts(result);
                    
                
                    return result;
                  } catch (error) {
                    console.error("Error al obtener Clientes:", error);
                    return [] as TopSellingProducts[];
                  }
          }

          async function getMonthlySales(year: number) {
            try {
              const result = await getMonthlySalesUseCase.invoke(year);
              setMonthlySales(result);
              return result;
            }
              catch (error) { 
              console.error("Error al obtener Ventas Mensuales:", error);
              return [] as any[];
            }
          }

          return {
            metrics,
            getMetrics,
            getLowStockProducts,
            lowStockProducts,
            getMonthlySales,
            monthlySales
          }
}